import { TeachTapUserFlag } from '../entities';

export const DEV_MODE_PRESS_COUNT = 15;

export const ALL_TEACHTAP_USER_FLAGS = [
  TeachTapUserFlag.AP_RESULTS_SUBMITTED,
  TeachTapUserFlag.SAT_FREE_POINTS_AVAILED,
  TeachTapUserFlag.SHOW_SAT_RESULTS_SCREEN,
];
